const selectedPartsDescription = {
  Bonnet_1_: 'Hood',
  Bottom_Seal_Left: 'Bottom Seal - Left',
  Bottom_Seal_Right: 'Bottom Seal - Right',
  Cab_Roof: 'Roof',
  Cab_Roof_Section: 'Cab Roof Section',
  Cab_Wheel_1_Left: 'Cab Wheel 1 - Left',
  Cab_Wheel_1_Right: 'Cab Wheel 1 - Right',
  Cab_Wheel_2_Left: 'Cab Wheel 2 - Left',
  Cab_Wheel_2_Right: 'Cab Wheel 2 - Right',
  Cab_Wheel_3_Left: 'Cab Wheel 3 - Left',
  Cab_Wheel_3_Right: 'Cab Wheel 3 - Right',
  Cab_Wheel_Mount_Left: 'Cab Wheel Mount - Left',
  Cab_Wheel_Mount_Right: 'Cab Wheel Mount - Right',
  A_CentreFront__1: 'Hood',
  A_CentreFront: 'Front Bumper',
  E_CentreRear: 'Rear Bumper',
  E_CentreRear__1: 'Trunk/Tailgate',
  E_CentreRear__2: 'Centre -Rear Left',
  I_Roof: 'Roof',
  Door_Left: 'Driver Door',
  Door_Right: 'Passenger Door',
  Door_Glass_Left: 'Driver Window',
  Door_Glass_Right: 'Passenger Window',
  Exhaust_Pipe_Left: 'Exhaust Pipe - Left',
  Exhaust_Pipe_RIght: 'Exhaust Pipe - Right',
  Front_Grill: 'Front - Grill',
  Front_Bumper_1_: 'Front Bumper',
  Fornt_Light_Left: 'Front Light - Left',
  Front_Light_Right: 'Front Light - Right',
  Front_Wing_Left: 'Front Wing - Left',
  Front_Wing_Right: 'Front Wing - Right',
  Fuel_Box_Left: 'Fuel Tank - Left',
  Fuel_Box_Right: 'Fuel Tank - Right',
  Left_Back_Window: 'Left - Back Window',
  G_LHSide: 'Driver Door',
  Left_Door_Glass: 'Driver Window',
  G_LHSide__1: 'Rear Passenger Door',
  Left_Secondary_Door_Glass: 'Rear Passenger Window',
  G_LHSide__2: 'Left - Door Post',
  H_LHFront: 'Left - Front',
  Left_Front_Light: 'Left Front Light',
  Left_Front_Lights: 'Left Front Lights',
  T_LHFrontWheel: 'Left Front Wheel',
  Left_Front_Window: 'Left Front Window',
  Left_Headlight: 'Left - Headlight',
  Left_Middle_Window: 'Left - Middle Window',
  Q_LHMirror: 'Left Mirror',
  F_LHRear: 'Left - Rear',
  F_LHRear__1: 'Rear Passenger Door',
  Left_Rear_Light: 'Left - Rear Light',
  Left_Rear_Lights: 'Left - Rear Lights',
  V_LHRearWheel: 'Left - Rear Wheel',
  Left_Rear_Window: 'Left - Rear Window',
  I_Roof__1: 'Right - Roof',
  L_Underbody: 'Left - Underbody',
  Left_Window: 'Left - Window',
  Load_Left: 'Load - Left',
  Load_Rear: 'Load - Rear',
  Load_Right: 'Load - Right',
  Load_Roof: 'Load - Roof',
  Load_Area: 'Truck Bed',
  Load_Wheel_1_Left: 'Load Wheel 1 - Left',
  Load_Wheel_1_Right: 'Load Wheel 1 - Right',
  Load_Wheel_2_Left: 'Load Wheel 2 - Left',
  Load_Wheel_2_Right: 'Load Wheel 2 - Right',
  Load_Wheel_3_Left: 'Load Wheel 3 - Left',
  Load_Wheel_3_Right: 'Load Wheel 3 - Right',
  Load_Wheel_Mount_Left: 'Load Wheel Mount - Left',
  Load_Wheel_Mount_Right: 'Load Wheel Mount - Right',
  Rear_Left_Light: 'Rear Left Light',
  Rear_Right: 'Rear - Right',
  Rear_Right_Light: 'Rear - Right Light',
  Rear_Window: 'Rear Window',
  Rear_Windscreen: 'Rear Window',
  Rear_Bumper: 'Rear Bumper',
  Rear_Light_Left: 'Rear Light - Left',
  Rear_Light_Right: 'Rear Light - Right',
  Rear_Panel_Left: 'Rear Panel - Left',
  C_RHSide: 'Passenger Door',
  Right_Door_Glass: 'Passenger Window',
  C_RHSide__1: 'Rear Passenger Door',
  Right_Secondary_Door_Glass: 'Rear Passenger Window',
  C_RHSide__2: 'Right - Door Post',
  B_RHFront: 'Right - Front',
  Right_Front_Light: 'Right Front Light',
  Right_Front_Lights: 'Right Front Lights',
  S_RHFrontWheel: 'Right Front Wheel',
  Right_Front_Window: 'Right Front Window',
  Right_Headlight: 'Right Headlight',
  Right_Middle_Window: 'Right - Middle Window',
  P_RHMirror: 'Right - Mirror',
  D_RHRear: 'Right - Rear',
  D_RHRear__1: 'Right Rear Door',
  Right_Back_Window: 'Right Rear Light',
  Right_Rear_Light: 'Right Rear Light',
  Right_Rear_Lights: 'Right Rear Lights',
  U_RHRearWheel: 'Right Rear Wheel',
  Right_Rear_Window: 'Right Rear Window',
  I_Roof__2: 'Left - Roof',
  L_Underbody__1: 'Right - Underbody',
  Right_Window: 'Right Window',
  Roof_Left: 'Roof - Left',
  Roof_Right_1_: 'Roof - Right',
  Roof_Glass_Left: 'Roof Glass - Left',
  Roof_Glass_Right: 'Roof Glass - Right',
  Stairs_Left: 'Stairs - Left',
  Stairs_Right: 'Stairs - Right',
  Windscreen_1_: 'Windscreen',
  N_Glass: 'Windshield',
  Wing_Mirror_Left: 'Left Side Mirror',
  Wing_Mirror_Right: 'Right Side Mirror',
};

export function SelectedPartsMapping(code) {
  return selectedPartsDescription[code] || code;
}
